// extracted by mini-css-extract-plugin
module.exports = {"status":"style_status__BJ8UI","pending":"style_pending__nWzMF","successful":"style_successful__K9G71","unsuccessful":"style_unsuccessful__Iyk5C","withdraw":"style_withdraw__e8kNk"};